<template>
  <div>
    <h3>BlockUI Sample</h3>
    
    <button @click="blockUI">blockUI</button>
    <BlockUI message="Welcome to Your Vue.js App" v-show="isBlock">
      <img src="@/assets/images/cmmnBG/tenor.gif" alt="">
    </BlockUI>
  </div>
</template>

<script>
export default {
  components:{
  },
  data(){
    return{
      // msg: 'Welcome to Your Vue.js App',
      // imageUrl : require('@/assets/images/cmmnBG/tenor.gif'),
      isBlock : false,
      
    }
  },
  methods:{
    blockUI(){
      this.isBlock = true;
      var temp = this;
      setTimeout(function () { 
        temp.isBlock = false;
      }, 5000)

    }
  }
}
</script>

<style scoped lang="scss">
  .samples::v-deep h3{
    margin-top: 50px;
  }
</style>


